import { createContext } from 'react';
import { BudgetScreen } from '../types';

export type BudgetScreenType = {
  budgetScreen: BudgetScreen;
  setBudgetScreen: React.Dispatch<React.SetStateAction<BudgetScreen>>;
};

export const BudgetScreenContext = createContext<BudgetScreenType | null>(null);
